import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme, GlobalStyles } from "./theme";
import { Button } from "./button";
import "./App.css";
import Signup from "./signup/signup";
import AuthManager from "./authmanager/authmanager";
import { React, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./authmanager/authcontext"; // Import the AuthProvider
import ProductDetails from "./productdetails/productdetails";
import { CartProvider } from "./cart/cart";
import { FinalizedCart } from "./cart/cart";
import { CheckoutForm } from "./ordermanager/ordermanager";
import Contact from "./contact/contact";
import { Payments } from "./payments/payment";
import ThankYou from "./thankyou/thankyou";
import About from "./about/about";
import Home from "./home/home";
import Author from "./author/author";
import AuthorList from "./author/authorlist";
import { GoogleOAuthProvider } from "@react-oauth/google"; // Import GoogleOAuthProvider

const GOOGLE_CLIENT_ID =
  "1056611449567-kf18a7go0blmtm94vi9uqmo9ai00ahnc.apps.googleusercontent.com";

const App = () => {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />

      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Router>
          <AuthProvider>
            {" "}
            {/* Wrap the entire application with AuthProvider */}
            <CartProvider>
              <Routes>
                <Route
                  path="/signup"
                  element={<Signup />}
                />
                <Route
                  path="/products/:id"
                  element={<ProductDetails toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/author/:id"
                  element={<Author toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/author"
                  element={<AuthorList toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/login"
                  element={
                    <AuthManager action="login" toggleTheme={toggleTheme} />
                  }
                />
                <Route
                  path="/cart"
                  element={<FinalizedCart toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/checkout"
                  element={<CheckoutForm toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/payments"
                  element={<Payments toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/home"
                  element={<Home toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/about"
                  element={<About toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/contact"
                  element={<Contact toggleTheme={toggleTheme} />}
                />
                <Route
                  path="/thank-you"
                  element={<ThankYou toggleTheme={toggleTheme} />}
                />
                <Route path="/" element={<Home toggleTheme={toggleTheme} />} />
              </Routes>
            </CartProvider>
          </AuthProvider>
        </Router>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
};

export default App;
